import React from "react";

const currency = (value) => (Number(value) || 0).toLocaleString("en-US", {
  style: "currency",
  currency: "USD",
});

const BudgetDebtList = ({ debts = [], title = "Secured Debts" }) => (
  <div className="card main-card">
    <div className="card-body">
      <h6>{title}</h6>
      {debts.length === 0 ? (
        <p className="mb-0">No {title.toLowerCase()} recorded.</p>
      ) : (
        <div className="table-responsive">
          <table className="table mb-0">
            <thead>
              <tr>
                <th scope="col">Creditor</th>
                <th scope="col">Type</th>
                <th scope="col">Balance</th>
                <th scope="col">Monthly Payment</th>
                <th scope="col">Months Behind</th>
              </tr>
            </thead>
            <tbody>
              {debts.map((debt) => (
                <tr key={debt.id}>
                  <td>{debt.creditor || "—"}</td>
                  <td>{debt.type || "—"}</td>
                  <td>{currency(debt.balance)}</td>
                  <td>{currency(debt.payment)}</td>
                  <td>{debt.monthsBehind ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
);

export default BudgetDebtList;
